import { useSelector } from 'react-redux';
import { Toast } from './toast';
import { css } from 'linaria';
const toastStyle = "t1qdyznf";
export const Toasts = () => {
  const toasts = useSelector(state => state.toasts);
  return <div className={toastStyle}>
      {toasts.map(toast => <Toast {...toast} key={toast.stamp} />)}
    </div>;
};

require("../../../.linaria-cache/src/connectors/toasts/toast-list.linaria.module.css");